import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ExpandedSecondary from "@components/WebsiteRevamp/ContentAsset/ExpandedSecondary/ExpandedSecondary"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./SolutionSection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
}

const SolutionSection = (props: Props) => {
	return (
		<Separator size={128}>
			<ContainerWrapper>
				<Typography
					className={styles.title}
					content={props.data.sectionTitle}
					variant={Variant.SectionTitle}
				/>
				<Separator />
				{props.data?.mainContent && (
					<ExpandedSecondary
						data={props.data?.mainContent}
						withAspectRation
					/>
				)}
				{/* <Separator /> */}
				{/* <div className={styles.bottomButton}>
					<Typography
						as={"h4"}
						content={props.data.sectionBottomTitle}
						fontWeight={600}
						size={Size.L}
						variant={Variant.Title}
						noPadding
					/>
					<Separator size={32} />
					<ButtonContainer>
						<ButtonComponent
							buttonType={"secondary"}
							className={styles.button}
							link={props.data.sectionBottomButtonLink}
							asLink
						>
							{props.data.sectionBottomButton}
						</ButtonComponent>
					</ButtonContainer>
				</div> */}
			</ContainerWrapper>
		</Separator>
	)
}

export default SolutionSection
